import site from '../../site';
import actionTypes from '../constants/action-types';
import statuses from '../constants/statuses';

const status = (state = statuses.SAVED, action) => {
  switch (action.type) {
    case site.actionTypes.CREATE_PAGE:
    case site.actionTypes.COPY_PAGE:
    case site.actionTypes.DELETE_PAGE:
    case site.actionTypes.SET_HOME_PAGE:
    case site.actionTypes.SET_CLEAN_URL_ENABLED: {
      if (state === statuses.SAVED || state === statuses.ERROR) {
        return statuses.UNSAVED;
      }
      break;
    }

    case actionTypes.SET_STATUS: {
      return action.payload.status;
    }
  }
  return state;
};

export default status;
